import template from './refreshBar.html';

function directive() {
  return {
    restrict: 'E',
    scope: {
      refresh: '=',
      type: '@'
    },
    template,
    link($scope) {
      $scope.reload = () => {
        $scope.refresh.reloading = true;
        $scope.refresh.reload();
      };

      $scope.close = () => {
        $scope.refresh.showNotifications = false;
        $scope.refresh.resetGlyph();
      };
    }
  };
}

export default function (ngModule) {
  ngModule.directive('refreshBar', directive);
}
